import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';
import { Reveal } from './motion/Reveal';
import { StaggerGroup, StaggerItem } from './motion/Stagger';

export const FAQ = () => {
  // A pergunta "Problema antigo ainda vale?" carrega a única urgência
  // genuína do site (prazo legal real de 5 anos, sem prazo inventado) —
  // estava na posição 4, onde a maioria de quem abre o FAQ nunca chega.
  // Subiu para a posição 2 para essa informação real aparecer mais cedo.
  const faqs = [
    {
      id: '1',
      question: 'Quanto custa?',
      answer: 'Nada adiantado! Você só paga uma pequena porcentagem se a gente ganhar o seu caso. Se não ganhar, você não paga nem um centavo. Justo, né?',
    },
    {
      id: '2',
      question: 'Problema antigo ainda vale?',
      answer: 'Provavelmente sim! No Brasil, você tem até 5 anos pra buscar indenização. Então se aconteceu há alguns anos, ainda pode dar tempo. Vem que a gente analisa!',
    },
    {
      id: '3',
      question: 'Quanto tempo demora?',
      answer: 'Depende do caso, mas em geral: acordos extrajudiciais saem em 30 a 90 dias. Se for pra justiça, pode levar de 6 meses a 2 anos. A gente te mantém informado em cada etapa!',
    },
    {
      id: '4',
      question: 'Que documentos preciso?',
      answer: 'O básico: seu documento, comprovante de reserva ou bilhete, cartão de embarque (se tiver) e qualquer prova do problema (fotos, e-mails, protocolos). Não tem tudo? Relaxa, a gente ajuda a conseguir!',
    },
    {
      id: '5',
      question: 'Como recebo o dinheiro?',
      answer: 'Super simples: quando o dinheiro cair, a gente desconta nossa porcentagem e transfere o resto direto pra sua conta. Sem complicação nenhuma.',
    },
    {
      id: '6',
      question: 'Preciso ir em audiência?',
      answer: 'Quase nunca! Nossos advogados te representam em tudo. Se por acaso precisar de você, avisamos com antecedência. Mas pode ficar tranquilo que é raridade.',
    },
    {
      id: '7',
      question: 'E se faltar documento?',
      answer: 'Sem problema! Nossa equipe pode ajudar a solicitar documentos junto às empresas. Muitas vezes conseguimos recuperar informações importantes mesmo sem a documentação original.',
    },
    {
      id: '8',
      question: 'Atendem voos internacionais?',
      answer: 'Sim! Atendemos voos nacionais e internacionais, desde que a origem ou destino seja no Brasil, ou que a companhia opere aqui. Pode mandar seu caso!',
    },
  ];

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 bg-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Reveal delay={0.1} className="text-center mb-16">
          <div className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold mb-4">
            <HelpCircle className="w-4 h-4" />
            <span>Tire suas dúvidas</span>
          </div>
          <h2
            data-testid="faq-title"
            className="text-3xl md:text-4xl font-bold text-slate-900 mb-4"
          >
            Perguntas frequentes
          </h2>
          <p className="text-lg text-slate-600">
            Ainda com dúvidas? A gente responde as mais comuns aqui embaixo.
          </p>
        </Reveal>

        {/* Accordion */}
        <StaggerGroup staggerDelay={0.1} startDelay={0.2} className="w-full max-w-3xl mx-auto">
          <Accordion type="single" defaultValue="1" collapsible className="w-full">
            {faqs.map((faq) => (
              <StaggerItem key={faq.id}>
                <AccordionItem
                  value={faq.id}
                  data-testid={`faq-item-${faq.id}`}
                  className="border-b border-slate-200 last:border-b"
                >
                  <AccordionTrigger className="text-left pl-4 md:pl-10 overflow-hidden text-slate-400 duration-200 hover:no-underline cursor-pointer py-6 data-[state=open]:text-blue-600 [&>svg]:hidden">
                    <div className="flex flex-1 items-center gap-4 md:gap-6">
                      <p className="text-xs font-mono text-slate-400">{faq.id.padStart(2, '0')}</p>
                      <h3 className="uppercase text-xl md:text-2xl lg:text-3xl font-bold tracking-tight">
                        {faq.question}
                      </h3>
                    </div>
                  </AccordionTrigger>

                  <AccordionContent className="text-slate-600 pb-6 pl-4 md:pl-20 pr-4 text-base leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </StaggerItem>
            ))}
          </Accordion>
        </StaggerGroup>
      </div>
    </section>
  );
};
